/**
 * @generated SignedSource<<5656f9cf44bedf2d0ea0ce5954bf0d8a>>
 * @relayHash 14f89ba2d6f0af29699c92366ec6237b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f2566183bb10f0288bc20ded5f54afacf2e47a389da7e7aab1371cde72a83988

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type agentMenuVerificationDropdownItemQuery$variables = {
  agentAri: string;
  cloudId: string;
  skip: boolean;
};
export type agentMenuVerificationDropdownItemQuery$data = {
  readonly agentStudio_agentById?: {
    readonly " $fragmentSpreads": FragmentRefs<"agentVerificationDropdownItem_AtlaskitRovoAgentComponents_agentRef">;
  } | null;
  readonly atlassianStudio_userSiteContext?: {
    readonly userPermissions?: {
      readonly " $fragmentSpreads": FragmentRefs<"agentVerificationDropdownItem_AtlaskitRovoAgentComponents_userPermissionsRef">;
    } | null;
  } | null;
};
export type agentMenuVerificationDropdownItemQuery = {
  response: agentMenuVerificationDropdownItemQuery$data;
  variables: agentMenuVerificationDropdownItemQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agentAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "agentAri"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "agentMenuVerificationDropdownItemQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentById",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_agentRef"
              }
            ]
          },
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "atlassianStudio_userSiteContext",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "AtlassianStudioUserProductPermissions",
                    "kind": "LinkedField",
                    "name": "userPermissions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_userPermissionsRef"
                      }
                    ]
                  }
                ],
                "type": "AtlassianStudioUserSiteContextOutput"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "agentMenuVerificationDropdownItemQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentById",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "isVerified"
                  }
                ],
                "type": "AgentStudioAssistant"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          },
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "atlassianStudio_userSiteContext",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "AtlassianStudioUserProductPermissions",
                    "kind": "LinkedField",
                    "name": "userPermissions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isAbleToGovernAgents"
                      }
                    ]
                  }
                ],
                "type": "AtlassianStudioUserSiteContextOutput"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f2566183bb10f0288bc20ded5f54afacf2e47a389da7e7aab1371cde72a83988",
    "metadata": {},
    "name": "agentMenuVerificationDropdownItemQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "825bd78a1fc122e2597a01b6fa038a20";

export default node;
